import { render, staticRenderFns } from "./FundingDetailsModal.vue?vue&type=template&id=047bfdfc&scoped=true&"
import script from "./FundingDetailsModal.vue?vue&type=script&lang=js&"
export * from "./FundingDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./FundingDetailsModal.vue?vue&type=style&index=0&id=047bfdfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bfdfc",
  null
  
)

export default component.exports